import {googleAds} from '../../../externalTrackers/index.js'

const CONVERSION_ID = 'AW-756219967'

const ONLINE_APPRAISAL_DEALER_NAME = 'tasación online'

const ONLINE_APPOINTMENT_LABEL = 'xx1uCLL6364bEL-AzOgC'
const IN_PERSON_APPOINTMENT_LABEL = 'l1TyCLvZ5q4bEL-AzOgC'

const track = googleAds({id: CONVERSION_ID})

const eventsMapping = {
  'Ad Inserted': ['Y6XKCKPOhJcBEL-AzOgC'],
  'Ad Insertion IO Date Confirmed': ['EYONCPCEivMBEL-AzOgC'],
  'Ad Insertion Viewed': ['i80eCM-p8okDEL-AzOgC'],
  'Instant Offer Request Confirmed': ['9TedCMrygfMBEL-AzOgC'],
  'Landing IO Date Confirmed': ['EYONCPCEivMBEL-AzOgC'],
  'Landing IO Offer Requested': ['9TedCMrygfMBEL-AzOgC'],
  'Landing IO Viewed': ['qoyWCOTDof0CEL-AzOgC', '_3QJCIO08okDEL-AzOgC']
}

export default ({event, isPage, properties}) => {
  const dealerName = properties?.dealer_name?.trim()?.toLowerCase()

  const isTaggableEvent = event === 'Ad Insertion IO Date Confirmed' || event === 'Landing IO Date Confirmed'

  if (isTaggableEvent && dealerName === ONLINE_APPRAISAL_DEALER_NAME) {
    track({label: ONLINE_APPOINTMENT_LABEL})
  }

  if (isTaggableEvent && dealerName !== ONLINE_APPRAISAL_DEALER_NAME) {
    track({label: IN_PERSON_APPOINTMENT_LABEL})
  }

  const labels = eventsMapping[event]

  labels && labels.map(label => track({label}))
  isPage && track({event: 'page_view', allowAdPersonalization: true})
}
